import React, { useState } from 'react';
import Slider from "react-slick";
import { Perk } from "./Perk";

import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

export const Perks = ({
  isLoggedIn,
  perksMenu,
  itemSelectHandler,
  optionSelectHandler,
  handleFormSubmit,
  submitDisabled,
  customExperienceHandler,
  holidayHelperHandler
}) => {
  const [isSelected, setSelected] = useState(false);

  const cbHandler = (event) => {
    setSelected(event.target.checked);
  };

  const settings = {
    dots: false,
    infinite: false,
    slidesToShow: 3,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2
        }
      },
      {
        breakpoint: 640,
        settings: {
          slidesToShow: 1
        }
      }
    ]
  };

  const groupedPerks = {
    Sports: [],
    LuxuryRolex: [],
    Seasonal: [],
    Lifestyle: [],
    Wellness: [],
    Mercedes: [],
    Entertainment: [],
    Travel: [],
    Luxury: [],
    Tiffany: []
  };

  // Group perks by category
  perksMenu.forEach(perk => {
    if (groupedPerks[perk.Category]) {
      groupedPerks[perk.Category].push(perk);
    }
  });

  // Sort each category: by Shields ascending, and for ties, show 'New' perks first
  /*Object.keys(groupedPerks).forEach(category => {
    groupedPerks[category].sort((a, b) => {
      // If same Shields, prioritize 'New' perks
      if (a.New !== b.New) {
        return a.New ? -1 : 1;
      }
      
      const shieldsA = a.Shields || 0;
      const shieldsB = b.Shields || 0;

      if (shieldsA !== shieldsB) {
        return shieldsA - shieldsB; // sort by Shields ascending
      }

      return 0;
    });
  });*/

  const renderCategory = (category, perks, isFirst) => {
    if (perks.length === 0) return null;

    if (category === "Travel") category = "Travel Curated by Wagner Bespoke Travel";

    if (category === "Mercedes") category = "Mercedes-Benz - 24 Month Lease";

    if (category === "LuxuryRolex") category = "Luxury - Rolex";

    return (
      <div key={category} className="perks__category">
        {!isFirst && <hr />}
        <h3 className="perks__category-title">{category}</h3>
        
        {category.includes("Travel") && (
          <div>
            <a
              href="http://www.wagnertravel.com/"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img
                className="travel-logo"
                src="https://s3.us-east-1.amazonaws.com/cdn.fanduel.com/shield-select/images/Wagner-Travel-logo.png"
                alt="Wagner Bespoke Travel"
                style={{ width: "200px", margin: "-10px 0 15px" }}
              />
            </a>
            <p className="perks__p">The Shield Select team is proud to partner with Wagner Travel to offer fully customizable travel experiences. Whether you're selecting from our curated travel packages or envisioning something unique, the Shield Select team will assist in coordinating every detail. Including length of stay, airfare, dinner reservations, and excursions. Let us help you turn your Shield Select redemption into a seamless and unforgettable getaway.</p>
            <br/>
          </div>
        )}

        {category.includes("Mercedes") && (
          <a
            href="https://www.mbmanhattan.com/"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img
              className="travel-logo"
              src="https://s3.us-east-1.amazonaws.com/cdn.fanduel.com/shield-select/images/mercedes-benz-logo.png"
              alt="Mercedes Benz of Manhattan"
              style={{ width: "300px", margin: "-10px 0 15px" }}
            />
          </a>
        )}

        <Slider {...settings}>
            {perks.map((data, key) => (
              <div key={key}>
                <Perk
                  key={`${category}-${key}`}
                  data={data}
                  itemSelectHandler={itemSelectHandler}
                  optionSelectHandler={optionSelectHandler}
                />
              </div>
            ))}
        </Slider>
      </div>
    );
  };

  if (!isLoggedIn) return null;

  const categoryOrder = ["Seasonal", "Lifestyle", "Wellness", "LuxuryRolex", "Mercedes", "Sports", "Entertainment", "Travel"];
  const filledCategories = categoryOrder.filter(cat => groupedPerks[cat].length > 0);

  return (
    <>
      <div className="small-12 small-offset-0 medium-10 medium-offset-1 large-8 large-offset-2 cell">
        <h4 className="perks__h4">Shield Select Rewards Menu</h4>
        <p className="perks__p">
          <em>
            *Events in the menu below are subject to availability. A FanDuel employee will reach out to confirm your attendance as soon as possible.
          </em>
        </p>
        <br />
      </div>

      <div className="small-12 small-offset-0 medium-12 medium-offset-0 large-10 large-offset-1 cell">
        <div className="perks__experience-choice">
          <h3 className="perks__category-title">HOLIDAY HELPER</h3>
          <p>Let the Shield Select team take the stress out of the season. Our <strong>Holiday Helpers</strong> are ready to assist with all your gifting and holiday celebration needs—from finding the perfect luxury items, to trimming your tree, to coordinating festive experiences. Tell us what you need, and we’ll make holiday magic happen!</p>
          <textarea rows="4" cols="50" onChange={holidayHelperHandler}></textarea>
        </div>
      </div>

      <div className="small-12 cell perks__menu">
        {filledCategories.map((category, index) =>
          renderCategory(category, groupedPerks[category], index === 0)
        )}
        <hr/>
      </div>

      <div className="small-12 small-offset-0 medium-12 medium-offset-0 large-10 large-offset-1 cell">
        <div className="perks__experience-choice">
          <h3 className="perks__category-title">Experience of your choice</h3>
          <p>Share your vision on how you want to use your shields for the perfect gift or experience, and we’ll collaborate with you every step of the way on how we can make it a reality!</p>
          <textarea rows="4" cols="50" onChange={customExperienceHandler}></textarea>
        </div>
      </div>

      <div className="small-12 cell">
        <form className="perks__form" id="submitForm" onSubmit={handleFormSubmit}>
          <p className="perks__p">
            <input type="checkbox" onChange={cbHandler} required />&nbsp;&nbsp;
            I agree to the <a href="https://www.fanduel.com/vipprogram/terms" target="_blank" rel="noreferrer">Terms & Conditions</a>
          </p>
          <button
            type="submit"
            className="button large"
            id="submitBtn"
            disabled={!isSelected || submitDisabled}
          >
            SUBMIT
          </button>
        </form>
      </div>
    </>
  );
};
